interface RemoveBackgroundBlobResult {
  blob: Blob;
  url: string;
}

interface RemoveBackgroundOptions {
  mode?: 'person' | 'product' | 'document' | 'car';
  backgroundColor?: string;
}

export const removeBackgroundFromBlob = async (
  imageBlob: Blob,
  accessToken: string,
  options: RemoveBackgroundOptions = {}
): Promise<RemoveBackgroundBlobResult> => {
  try {
    const formData = new FormData();
    formData.append('image_file', imageBlob, 'image.png');

    if (options.mode) {
      formData.append('mode', options.mode);
    }

    if (options.backgroundColor) {
      const color = options.backgroundColor.replace('#', '');
      if (/^[0-9A-Fa-f]{6}$/.test(color)) {
        formData.append('background_color', color);
      }
    }

    const response = await fetch(
      `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/remove-background`,
      {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${accessToken}`,
        },
        body: formData,
      }
    );

    if (!response.ok) {
      let errorMessage = `API error: ${response.status}`;
      try {
        const errorData = await response.json();
        errorMessage = errorData.error || errorMessage;
      } catch {
      }
      throw new Error(errorMessage);
    }

    const outputBlob = await response.blob();
    const url = URL.createObjectURL(outputBlob);

    return { blob: outputBlob, url };
  } catch (error) {
    console.error('Error removing background:', error);
    throw new Error(error instanceof Error ? error.message : 'Failed to remove background');
  }
};
